import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Loader2, Download } from "lucide-react";
import { MediaKitPreview } from "@/components/mediakit/MediaKitPreview";
import { generateMediaKitPdf } from "@/lib/mediaKitPdf";
import { toast } from "sonner";

export default function MediaKitPublic() {
  const { shareId } = useParams();
  const [state, setState] = useState("loading");
  const [kit, setKit] = useState(null);
  const [pdfBusy, setPdfBusy] = useState(false);

  useEffect(() => {
    // Ask search engines not to index public media kits.
    const meta = document.createElement("meta");
    meta.name = "robots"; meta.content = "noindex, nofollow";
    document.head.appendChild(meta);
    api.get(`/public/media-kit/${shareId}`).then((r) => { setKit(r.data); setState("ok"); })
      .catch(() => setState("unavailable"));
    return () => { try { document.head.removeChild(meta); } catch { /* */ } };
  }, [shareId]);

  const download = async () => {
    setPdfBusy(true);
    try { await generateMediaKitPdf(kit); toast.success("Media kit downloaded"); }
    catch { toast.error("Could not generate the PDF"); }
    finally { setPdfBusy(false); }
  };

  if (state === "loading") return <div className="flex min-h-screen items-center justify-center bg-[#FAF9F6]"><Loader2 className="h-6 w-6 animate-spin text-emerald-600" /></div>;
  if (state === "unavailable") return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-[#FAF9F6] px-4 text-center" data-testid="media-kit-unavailable">
      <h1 className="font-display text-2xl font-bold text-zinc-900">Media kit unavailable</h1>
      <p className="mt-2 text-zinc-500">This link is no longer active. The creator may have turned off sharing or generated a new link.</p>
      <a href="/" className="mt-5"><Button className="rounded-full bg-emerald-600 hover:bg-emerald-700">Go to Nearfluence</Button></a>
    </div>
  );

  return (
    <div className="min-h-screen bg-[#FAF9F6] py-8">
      <div className="mx-auto max-w-2xl px-4" data-testid="media-kit-public">
        <div className="mb-4 flex items-center justify-between">
          <a href="/" className="font-display text-lg font-bold text-emerald-700">Nearfluence</a>
          <Button data-testid="public-download-pdf" onClick={download} disabled={pdfBusy} className="rounded-full bg-emerald-600 hover:bg-emerald-700">{pdfBusy ? <Loader2 className="mr-1 h-4 w-4 animate-spin" /> : <Download className="mr-1 h-4 w-4" />} Download PDF</Button>
        </div>
        <MediaKitPreview kit={kit} />
        <p className="mt-4 text-center text-xs text-zinc-400">This is a public media kit shared by the creator on Nearfluence.</p>
      </div>
    </div>
  );
}
